const routes = [
    {
        path: 'solicitacoes/:id',
        name: 'Anexar_documentacao_faltante_dispensaouinexigibilidade',
        component: () => import('./fornecerdocumentosfaltante/DocumentacaoFaltante.vue'),
        meta: {
            rules: ['LICITACOES-04'],
        },
    },
    {
        path: 'solicitacoes/:id',
        name: 'Inserir_justificativa_dispensaouinexigibilidade',
        component: () => import('./justificativa/Justificativa.vue'),
        meta: {
            rules: ['LICITACOES-04'],
        },
    },
    {
        path: 'solicitacoes/:id',
        name: 'Documentacao_recebida_dispensaouinexigibilidade',
        component: () => import('./documentosdaempresa/DocumentosDaEmpresa.vue'),
        meta: {
            rules: ['LICITACOES-04'],
        },
    },
    {
        path: 'solicitacoes/:id',
        name: 'Analisar_justificativa_dispensaouinexigibilidade',
        component: () => import('./analisarjustificativa/AnalisarJustificativa.vue'),
        meta: {
            rules: ['LICITACOES-19'],
        },
    },
];

export default routes;
